import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/mt7rk-arrow.svg'


const _hoisted_1 = {
  key: 0,
  class: "author-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "wrap-author" }
const _hoisted_5 = {
  key: 0,
  class: "author-wrap"
}
const _hoisted_6 = { class: "box-shadow reversed" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "author-content" }
const _hoisted_9 = { class: "author-name" }
const _hoisted_10 = { class: "country" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "المقالات العقارية Related Articles", -1)
const _hoisted_13 = { class: "author-wrap" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "author-content" }
const _hoisted_17 = { class: "author-name" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "bio" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 1,
  class: "img-wrap"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 2,
  class: "caption"
}
const _hoisted_30 = {
  key: 2,
  class: "vid-wrap"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = {
  key: 2,
  class: "caption"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    id: "lightboxWrap",
    class: _normalizeClass(_ctx.lang)
  }, [
    _createElementVNode("div", {
      class: "bg",
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.closeLightbox())),
      style: _normalizeStyle({backgroundColor: _ctx.color})
    }, null, 4),
    (typeof _ctx.src === 'object' && _ctx.src !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            href: "",
            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.closeLightbox && _ctx.closeLightbox(...args))),
            class: _normalizeClass('close btn auto border bc-'+_ctx.colorName+' '+_ctx.colorName)
          }, _hoisted_3, 2),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.src)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      src: _ctx.src.custom_fields.image.sizes.medium
                    }, null, 8, _hoisted_7)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.src.post_title), 1),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.src.custom_fields.country), 1),
                    _createElementVNode("div", {
                      class: "bio",
                      innerHTML: _ctx.src.post_content
                    }, null, 8, _hoisted_11)
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_12,
            (_ctx.related)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.related, (post, index) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("a", {
                      href: "",
                      class: "box-shadow reversed",
                      onClick: $event => (_ctx.goToBlog(post,$event))
                    }, [
                      _createElementVNode("img", {
                        src: post.custom_fields.image.sizes.medium
                      }, null, 8, _hoisted_15)
                    ], 8, _hoisted_14),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("p", _hoisted_17, [
                        _createElementVNode("a", {
                          href: "",
                          onClick: $event => (_ctx.goToBlog(post,$event))
                        }, _toDisplayString(post.post_title), 9, _hoisted_18)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("p", {
                          innerHTML: post.custom_fields.intro_text
                        }, null, 8, _hoisted_20)
                      ])
                    ])
                  ]))
                }), 256))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_ctx.type == 'image')
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("a", {
              href: "",
              onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.closeLightbox && _ctx.closeLightbox(...args))),
              class: _normalizeClass('close btn auto border bc-'+_ctx.colorName+' '+_ctx.colorName)
            }, _hoisted_23, 2),
            (_ctx.index > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "arrow arrow-left right",
                  onClick: _cache[3] || (_cache[3] = $event => (_ctx.changeSlide(-1)))
                }, _hoisted_25))
              : _createCommentVNode("", true),
            (_ctx.index < _ctx.totalSlide - 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "arrow arrow-right",
                  onClick: _cache[4] || (_cache[4] = $event => (_ctx.changeSlide(1)))
                }, _hoisted_27))
              : _createCommentVNode("", true),
            _createElementVNode("img", {
              src: _ctx.src,
              onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.closeLightbox && _ctx.closeLightbox(...args)))
            }, null, 8, _hoisted_28),
            (_ctx.caption)
              ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.caption), 1))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.type == 'video')
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("a", {
                href: "",
                onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.closeLightbox && _ctx.closeLightbox(...args))),
                class: _normalizeClass('close btn auto border bc-'+_ctx.colorName+' '+_ctx.colorName)
              }, _hoisted_32, 2),
              (_ctx.index > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "arrow arrow-left right",
                    onClick: _cache[7] || (_cache[7] = $event => (_ctx.changeSlide(-1)))
                  }, _hoisted_34))
                : _createCommentVNode("", true),
              (_ctx.index < _ctx.totalSlide - 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "arrow arrow-right",
                    onClick: _cache[8] || (_cache[8] = $event => (_ctx.changeSlide(1)))
                  }, _hoisted_36))
                : _createCommentVNode("", true),
              _createElementVNode("div", { innerHTML: _ctx.src }, null, 8, _hoisted_37),
              (_ctx.caption)
                ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(_ctx.caption), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
  ], 2))
}